import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {IBank} from "../../../../../../../utils/interfaces/my_documents/IBank";


const useApiUpdateBank = (): UseMutationResult<IBank, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()

    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IBank> {
        try {
            const response = await put(`/api/company/${company_token}/my_documents/bank/${pk}/`, data);
            return response.data as IBank;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IBank, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetBank', data.id]});
            await queryClient.invalidateQueries({queryKey: ["useApiGetBanks"]});
        },
    });
};


export default useApiUpdateBank;